function initFloatAddToBagBar() {
  // pai de todos
  // onde vai a info quando estiver flutuando
  const $productInfoWrapper = document.querySelector('[data-attribute="pdp-product-grid"]');
  if (!$productInfoWrapper) {
    return;
  }

  // onde vai a info quando não estiver flutuando
  const $productInfoContainer = document.querySelector('.product__info-container');
  if (!$productInfoContainer) {
    return;
  }

  // info que vai flutuar ou não
  const $floatBar = $productInfoWrapper.querySelector('.buy-information');
  if (!$floatBar) {
    return;
  }

  const $space = $productInfoWrapper.querySelector('.buy-information-space');
  if (!$space) {
    return;
  }

  const $header = document.getElementById('shopify-section-header');
  const headerHeight = $header.offsetHeight;

  if (!$productInfoWrapper.classList.contains('gift-card')) {
    window.addEventListener('scroll', handleScroll);
  }

  function handleScroll() {
    const spaceBottom = $space.getBoundingClientRect().bottom;
    spaceBottom <= headerHeight ? enableFloat() : disableFloat();
  }

  function enableFloat() {
    $space.style.height = $floatBar.offsetHeight + 'px';
    $floatBar.classList.add('is-float', 'page-width');
    $productInfoWrapper.appendChild($floatBar);
  }

  function disableFloat() {
    $space.style.height = '0';
    $floatBar.classList.remove('is-float', 'page-width');
    $productInfoContainer.insertBefore($floatBar, $space);
  }

  if (document.location.href.indexOf('gift-card') === -1) {
    handleScroll();
  }
}

if (window.innerWidth >= 768) {
  initFloatAddToBagBar();
}
